export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin',
        defaultAdminRoleName: 'Admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'uk'
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    static readonly grid = {
        defaultPageSize: 10
    };

    //JS report front end taraflı kullanılmak istenirse bu bilgiler doldurulacak.
    static readonly jsReportSettings = {
        url: '...',
        userName: '..',
        password: '...',
        indicatorTemplateName: 'YOK_GostergeRaporu',
        evaluationTemplateName: 'YOK_IcDegerlendirmeRaporu'
    };

    static readonly ReviewForm = {
        ReviewFormStringSeperator: '/#/',
        ReviewFormAddExpStringSeperator: '/##/'
    };

    static readonly IndicatorPerformance = {
        RouteSeperator: ','
    }
}



// WEBPACK FOOTER //
// ./src/shared/AppConsts.ts